import TokenHandler from './src/TokenHandler';

export default TokenHandler;
